import { canUsePermission, type PermissionUser } from "../../lib/auth";

/** 行程页面与操作统一权限码。 */
export const ITINERARY_PERMISSIONS = {
  access: "opportunity.itinerary:access",
  previewAccess: "opportunity.itinerary_preview:access",
  mySharesAccess: "opportunity.itinerary_share:access",
  editorAccess: "opportunity.itinerary_editor:access",
  create: "opportunity.itinerary:create",
  generate: "opportunity.itinerary:generate",
  update: "opportunity.itinerary:update",
  export: "opportunity.itinerary:export",
  share: "opportunity.itinerary:share",
  finalize: "opportunity.itinerary:finalize",
  table: "opportunity.itinerary:table",
  copy: "opportunity.itinerary:copy",
  move: "opportunity.itinerary:move",
} as const;

/** 列表和编辑器共用的预览父权限及六项子操作，不依赖岗位名称。 */
export function getItineraryPreviewPermissions(user: PermissionUser | null | undefined) {
  const canPreview = canUsePermission(user, ITINERARY_PERMISSIONS.previewAccess);
  const can = (permission: string) => canPreview && canUsePermission(user, permission);
  return {
    canPreview,
    canExport: can(ITINERARY_PERMISSIONS.export),
    canShare: can(ITINERARY_PERMISSIONS.share),
    canViewTable: can(ITINERARY_PERMISSIONS.table),
    canCopy: can(ITINERARY_PERMISSIONS.copy),
    canMove: can(ITINERARY_PERMISSIONS.move),
    canFinalize: can(ITINERARY_PERMISSIONS.finalize),
  };
}
